import {
  Component,
  ViewChildren,
  Input,
  Output,
  OnChanges,
  EventEmitter,
  AfterViewInit,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  UntypedFormBuilder,
  AbstractControl,
} from '@angular/forms';
import * as _ from 'lodash';

import * as utils from 'utils/utils';

import { TableComponent } from '../../../table/table/table.component';

import { TeamService } from '../../team.service';
import { userData } from '../user-data';
import { permissionsTooltips } from '../permissions-tooltips';

@Component({
  moduleId: module.id,
  selector: 'add-edit-user-form',
  templateUrl: 'add-edit-user-form.component.html',
  styleUrls: ['add-edit-user-form.component.scss'],
})
export class AddEditUserFormComponent extends TableComponent implements OnChanges, AfterViewInit {
  form: UntypedFormGroup;
  segmentData = userData;
  @ViewChildren('textInput') inputs: any;

  @Input() isAddNewUser: boolean;

  @Input() data: any = {
    firstName: '',
    secondName: '',
    email: '',
    phone: '',
    isAdministrator: false,
    productCatalogView: false,
    damView: false,
    repository: false,
    fitmentsView: false,
    productCatalogEdit: false,
    damEdit: false,
    fitmentsEdit: false,
  };

  constructor(
    private fb: UntypedFormBuilder,
    private teamService: TeamService,
  ) {
    super();
    this.createForm();
  }

  // hooks
  ngOnChanges() {
    this.updateFormData();
  }

  ngAfterViewInit() {
    _.delay(() => {
      this.inputs.first.nativeElement.focus();
    }, 1000);
  }

  // getters
  get isAdmin() {
    return this.form.get('isAdministrator').value;
  }

  get formValue(): any {
    return this.form.value;
  }

  get isFormValid(): boolean {
    return this.form.valid;
  }

  // public
  /*
    redefined method hasError of TableComponent
  */
  public hasError(field: any, form: UntypedFormGroup | AbstractControl): boolean {
    // add checking 'touched' for form control
    return utils.hasError(field, form) && form.get(field).touched;
  }

  public reset(): void {
    if (this.form) { this.form.reset(); }
  }

  public updateFormPermissions(permissions: any): void {
    if (_.find(permissions, {permission: 'admin'})) {
      this.form.controls['isAdministrator'].setValue(true);
    }
    if (_.find(permissions, {permission: 'catalog-view'})) {
      this.form.controls['productCatalogView'].setValue(true);
    }
    if (_.find(permissions, {permission: 'catalog-edit'})) {
      this.form.controls['productCatalogEdit'].setValue(true);
    }
    if (_.find(permissions, {permission: 'dam-view'})) {
      this.form.controls['damView'].setValue(true);
    }
    if (_.find(permissions, {permission: 'dam-edit'})) {
      this.form.controls['damEdit'].setValue(true);
    }
    if (_.find(permissions, {permission: 'fitments'})) {
      this.form.controls['fitmentsEdit'].setValue(true);
    }
    if (_.find(permissions, {permission: 'repository'})) {
      this.form.controls['repository'].setValue(true);
    }
  }

  public updateFormInvite(invite: any): void {
    if (this.form.get('firstName')) { this.form.get('firstName').setValue(invite.first_name); }
    if (this.form.get('lastName')) { this.form.get('lastName').setValue(invite.last_name); }
    if (this.form.get('phone')) { this.form.get('phone').setValue(invite.phone); }
    if (this.form.get('email')) { this.form.get('email').setValue(invite.email); }

    const permissions = _.split(invite.permissions, '|');
    if (_.indexOf(permissions, 'admin') >= 0) {
      this.form.controls['isAdministrator'].setValue(true);
    }
    if (_.indexOf(permissions, 'catalog-view') >= 0) {
      this.form.controls['productCatalogView'].setValue(true);
    }
    if (_.indexOf(permissions, 'catalog-edit') >= 0) {
      this.form.controls['productCatalogEdit'].setValue(true);
    }
    if (_.indexOf(permissions, 'dam-view') >= 0) {
      this.form.controls['damView'].setValue(true);
    }
    if (_.indexOf(permissions, 'dam-edit') >= 0) {
      this.form.controls['damEdit'].setValue(true);
    }
    if (_.indexOf(permissions, 'fitments') >= 0) {
      this.form.controls['fitmentsEdit'].setValue(true);
    }
    if (_.indexOf(permissions, 'repository') >= 0) {
      this.form.controls['repository'].setValue(true);
    }
  }

  // handlers
  onCheckboxChange(event: any, name: string) {
    this.form.get(name).setValue(event.target.checked);
  }

  // private
  private createForm() {
    this.form = new UntypedFormGroup({});
    _.forEach(this.segmentData, (item: any) => {
      this.form.addControl(item.field_map,
        new UntypedFormControl(this.data[item.field_map], this.getItemValidators(item.validation))
      );
    });
  }

  private updateFormData() {
    _.forEach(this.segmentData, (item: any) => {
      if (this.data[item.field_map]) {
        this.form.get(item.field_map).setValue(this.data[item.field_map]);
      }
    });
  }

  private getInnerHTML(name: string) {
    return permissionsTooltips[name] ? permissionsTooltips[name] : '';
  }

}
